// extracted by mini-css-extract-plugin
export default {"container":"KTTXDd","text":"akaHZ4","spinner":"j33YNY"};